module.exports = __webpack_public_path__ + "static/img/8.f63ab6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/8.png
// module id = rGvx
// module chunks = 0